import { ChangeDetectionStrategy, Component } from '@angular/core';
import { YEAR_DATE_FORMAT } from '../../../common/constants';
import { format } from 'date-fns';

@Component({
    selector: 'login-footer',
    templateUrl: './login-footer.component.html',
    styleUrls: ['./login-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginFooterComponent {
  currentYear: string = format(new Date(), YEAR_DATE_FORMAT);
}
